import { Button, Space } from '@/components';
import {
  type ProjectSearchFormType,
  ProjectSearchSchema,
  initialValueOfProjectSearchForm,
} from '@/features/search/_models/projects-search';
import dayjs from 'dayjs';
import type { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useProjectsSearchFormProviderState } from '../_common/ProjectsSearchAccordionProvider';

export const SearchButton: FC<{
  formId: string;
  onResetPayment: () => void;
}> = ({ formId, onResetPayment }) => {
  const { t } = useTranslation();
  const { reset } = useFormContext<ProjectSearchFormType>();
  const { type } = useProjectsSearchFormProviderState();
  const { getValues } = useFormContext<ProjectSearchFormType>();
  return (
    <Space>
      <Button
        htmlType="button"
        type="default"
        onClick={async () => {
          const nullifiedValues = Object.keys(ProjectSearchSchema.shape).reduce(
            (acc, key) => {
              acc[key] = null;
              return acc;
            },
            {} as Record<string, null>,
          );
          const fiscalYear = getValues('fiscalYear');
          reset({
            ...nullifiedValues,
            ...initialValueOfProjectSearchForm,
            categories: null,
            fiscalYear:
              type === 'group'
                ? fiscalYear
                : dayjs().year(initialValueOfProjectSearchForm.fiscalYear),
          });
          onResetPayment();
        }}
      >
        {t('search-clear')}
      </Button>
      <Button form={formId} htmlType="submit" type="primary">
        {t('search-by')}
      </Button>
    </Space>
  );
};
